<template>
  <div
    :class="className"
    :style="{'background-image': 'url(' + backgroundImage + ')', height: height, width: width}"
  ></div>
</template>
<script>
export default {
  name: "BaseFilteredBackground",
  props: {
    backgroundImage: {
      type: String,
      default: null
    },
    className: {
        type: String,
        default: 'aup-filtered-background'
    },
    height: {
        type: String,
        default: '100%'
    },
    width: {
        type: String,
        default: '100%'
    },
  }
};
</script>

<style lang="scss">
.aup-filtered-background {
  position: absolute;
  //Fix for blurred edges when using filter
  transform: scale(1.2);
  background-size: cover;
  filter: blur(20px) brightness(50%);
  &--light {
      filter: blur(10px) brightness(80%)
  }
}
</style>
